import {
  ItemWrapper,
  ContentWrapper,
  Error,
  InputWrapper,
  ButtonsWrapper,
  InputContainer,
} from "../../styles";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";

import { CNYProps, FormInputs } from "../../../../../../types/walletTypes";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { savedCNYData } from "../../../../redux/formDataSlice";
import { Button } from "../../../../../../components/common/Button";

import { InputPhone } from "../../../../../../components/common/InputPhone";
import { Input } from "../../../../../../components/common/Input";
import CustomSelect from "../../../../../../components/common/CustomSelect";
import { CNYIDTypes, Relationships } from "../../../../const";
import React from "react";

const BeneficiaryUnionPayForm = ({ handleNext, handlePrevious }: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormInputs>({ defaultValues: getSavedData || {} });

  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  return (
    <ContentWrapper>
      <ItemWrapper>
        <InputWrapper>
          <Controller
            name="receiverFirstName"
            control={control}
            rules={{ required: "First name is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="First name"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors.receiverFirstName}
                labelColor="#FFFFFF"
              />
            )}
          />
          <Error>{errors?.receiverFirstName?.message}</Error>
        </InputWrapper>

        <InputWrapper>
          <Controller
            name="receiverLastName"
            control={control}
            rules={{ required: "Last name is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="Last name"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors.receiverLastName}
                labelColor="#FFFFFF"
              />
            )}
          />
          <Error>{errors?.receiverLastName?.message}</Error>
        </InputWrapper>
      </ItemWrapper>

      <InputWrapper>
        <Controller
          name="receiverMobileNumber"
          control={control}
          rules={{ required: "Phone number is required" }}
          render={({ field }) => (
            <InputPhone
              label="Phone number"
              field={field}
              defaultCountry="CN"
            />
          )}
        />
        <Error>{errors?.receiverMobileNumber?.message}</Error>
      </InputWrapper>

      <ItemWrapper>
        <InputContainer>
          <InputWrapper>
            <Controller
              name="receiverIdType"
              control={control}
              rules={{ required: "ID type is required" }}
              render={({ field }) => (
                <CustomSelect
                  value={field.value}
                  options={CNYIDTypes.filter(
                    (data) =>
                      ![
                        "UNIFIED_SOCIAL_CREDIT_ID",
                        "HONGKONG_MACAO_TAIWAN_PERMIT",
                        "BUSINESS_REGISTRATION_CERT",
                        "OTHER",
                      ].includes(data.value),
                  )}
                  onChange={field.onChange}
                  $width="100%"
                  placeholder="ID Type"
                  lightBorder
                />
              )}
            />
            {<Error>{errors?.receiverIdType?.message}</Error>}
          </InputWrapper>
        </InputContainer>

        <InputWrapper>
          <Controller
            name="receiverIdNumber"
            control={control}
            rules={{ required: "ID number is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="ID Number"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors?.receiverIdNumber}
              />
            )}
          />
          {<Error>{errors?.receiverIdNumber?.message}</Error>}
        </InputWrapper>
      </ItemWrapper>

      <InputWrapper>
        <Controller
          name="receiverRelationship"
          control={control}
          rules={{ required: "Field is required" }}
          render={({ field }) => (
            <CustomSelect
              options={Relationships}
              $width="100%"
              placeholder="Relationship"
              value={field.value}
              onChange={field.onChange}
              lightBorder
            />
          )}
        />
        <Error>{errors?.receiverRelationship?.message}</Error>
      </InputWrapper>

      <ButtonsWrapper>
        <Button
          onClick={handlePrevious}
          label="Back"
          height="48px"
          theme="alternate"
          width="203px"
        />
        <Button
          onClick={handleSubmit(onSubmit)}
          label="Continue"
          height="48px"
        />
      </ButtonsWrapper>
    </ContentWrapper>
  );
};

export default BeneficiaryUnionPayForm;
